import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {SeoService} from '../shared/services/seo.service';

@Component({
    selector: 'mbnm-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HelpComponent implements OnInit {

  tiles: Array<any>;

  constructor(public seoService: SeoService) { }

  ngOnInit() {
    this.tiles = [
      {
        'link': '/help/faq',
        'title': 'FAQ - Frequently Asked Questions',
        'caption': 'Most frequently asked questions and answers including information about ordering, products, shipping and pricing. This guide has all the information you need to get started.',
        'image': null,
        'icon': 'faq'
      },
      {
        'link': '/help/matboard-101',
        'title': 'Matboard 101',
        'caption': 'Complete guide on picture matting basics so you can get the perfect matboard for your project. Learn about the difference between low and high quality matting.',
        'image': null,
        'icon': 'matboard-101'
      },
      {
        'link': '/help/measuring-matboards',
        'title': 'Measuring Your Matboards',
        'caption': 'Instructions on choosing the perfect dimensions for your next matboard including the outer size, opening size, reveal and what they all mean. See our short video as well!',
        'image': null,
        'icon': 'measuring-matboard'
      },
      {
        'link': '/help/mounting-art',
        'title': 'How to Mount Your Artwork',
        'caption': 'This guide will go through the various methods of mounting your artwork so you can get them properly displayed in frames, show kits or on their own.',
        'image': null,
        'icon': 'mount-frame'
      },
      {
        'link': '/help/selling-art-online-with-matboard',
        'title': 'Sell Your Art Online',
        'caption': 'See how you can sell your artwork on online marketplaces like Etsy and at shows across the country. Learn from artists using Matboard and More products.',
        'image': null,
        'icon': 'sell-art'
      },
      {
        'link': '/help/mats-art-shows',
        'title': 'Guide to Matting for Art Shows',
        'caption': 'Step by step process for choosing the right matting products for your next art show. Learn about choosing colors, sizes and show kits for your art.',
        'image': null,
        'icon': 'guide-for-artShow'
      },
      {
        'link': '/help/pre-cut-mats-guide',
        'title': 'Pre Cut vs. DIY',
        'caption': 'Compare purchasing pre cut matting online as opposed to cutting your own matboards. Learn about the time and cost savings that will help your art business thrive!',
        'image': null,
        'icon': 'diy'
      },
      {
        'link': '/help/framing-components',
        'title': 'Framing Components',
        'caption': 'Overview of the various components commonly used in a picture frame including the moulding, glazing, matboard and backing board.',
        'image': null,
        'icon': 'framing-component'
      },
      {
        'link': '/help/fun-matboard-ideas',
        'title': 'Creative Matboard Ideas',
        'caption': 'Guide to using matboard products creatively for amazing presentations and displays. Get gift ideas for the holidays and other special occasions.',
        'image': null,
        'icon': 'ideas'
      }
    ];

    this.seoService.setMetaData({
      title: 'Help Pages and Guides - Matboard and More',
      description: 'Matboard and More framing and matboard guides including mounting, measuring and creating the best display for your art work.',
      og: {
        image: this.tiles[0].image
      }
    });
  }

}
